<template>
    <div :class="['form-group field-validation-error']">
        {{ error }}
    </div>
</template>

<script>
export default {
    name: "FormError",
    props: {
        error: {
            type: String,
            required: false
        }
    }
}

</script>

<style scoped>
.field-validation-error {
    color: red;
    position:absolute;
    top:101%;
    left:0;
    font-size:10px;
}
</style>
